
import { FormGroup, FormControl, Validators, ControlContainer } from '@angular/forms';
import { LibelleLogement } from './../../../constants/libelle-logement';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { Subscription } from 'rxjs';
import { SitFamForm, SitFamFormValue, SitFamModel } from './models/sitfam.model';

@Component({
  selector: 'app-sitfam',
  templateUrl: './sitfam.component.html',
  styleUrls: ['./sitfam.component.css']
})
export class SitfamComponent implements OnInit, AfterContentChecked, OnDestroy {
  
  @Input() name : string;

  @Input() sitFamModel: SitFamModel = new SitFamModel();
  
  @Output() sitFamModelEvent = new EventEmitter<SitFamModel>();
  
  parentForm : FormGroup;

  /**
   * Liste des subscribers
   */
  subscribers : Array<Subscription> = new Array();

  sitFamForm : FormGroup<SitFamForm>;

  sitFamValue = "";
  
  libelleLogement = LibelleLogement;

  /**
   * @param controlContainer 
   * @param cd 
   */
  constructor(
    private readonly controlContainer: ControlContainer,
    private readonly cd: ChangeDetectorRef) {

  }

  /**
   * Initialisation
   */
  ngOnInit() {
    this.sitFamForm = new FormGroup<SitFamForm>({
      nbEnfant: new FormControl<string>('0', {nonNullable:true, validators:Validators.required})
    });

    this.parentForm = this.controlContainer?.control as FormGroup;
    this.parentForm.addControl(this.name, this.sitFamForm);

    if (this.sitFamModel.enCouple !== undefined) {
      this.mapSessionData();
      this.sitFamModelEvent.emit(this.sitFamModel);
    } 

    this.subscribers.push(
      this.sitFamForm.valueChanges.subscribe((data : SitFamFormValue) => {
        this.mapperSitFam(data);
      })
    );
  }

  /**
   * 
   */
  ngAfterContentChecked() {
    this.cd.detectChanges();
  }
  
  /**
   * A la destruction du composant (implémentation de OnDestroy) : 
   * On vide les subscribtions effectuées à l'init
   */
  ngOnDestroy(): void {
    this.subscribers.forEach(sub => sub.unsubscribe());
    this.parentForm.removeControl(this.name);
    const sitFamData = new SitFamModel();
    this.sitFamModelEvent.emit(sitFamData);
  }

  /**
   * Mapping donnée session --> vers le form
   */
  mapSessionData() {        
    
    if (this.sitFamModel.enCouple) {
      this.sitFamValue = "VIM";
    } else {
      this.sitFamValue = "CEL";
    }

    this.sitFamForm.get('nbEnfant').patchValue(this.sitFamModel.nbEnfants.toString());
  }

  /**
   * mapping form --> objet model + emit
   * @param data 
   */
  mapperSitFam(data : SitFamFormValue) {
    
    let isCouple = undefined;
    if (data.situationFamiliale === "VIM") {
      isCouple = true;
    } else if (data.situationFamiliale === "CEL") {
      isCouple = false;
    }

    this.sitFamModel = new SitFamModel();
    this.sitFamModel.setEnCouple(isCouple);
    this.sitFamModel.setNbEnfants(Number(data.nbEnfant));
    this.sitFamModelEvent.emit(this.sitFamModel);
  }

  /**
   * fonction appelée lors d'un clic sur +
   */
  clickBtnPlus(): void {
    const sNombreEnfant = this.sitFamForm.controls['nbEnfant'].value;
    let nombreEnfant = Number(sNombreEnfant);
    if (nombreEnfant < 20) {
      nombreEnfant++;
    }
    this.sitFamForm.get('nbEnfant').patchValue(nombreEnfant.toString());
  }

  /**
   * fonction appelée lors d'un clic sur -
   */
  clickBtnMoins(): void {    
    const sNombreEnfant = this.sitFamForm.controls['nbEnfant'].value;
    let nombreEnfant = Number(sNombreEnfant);
    if (nombreEnfant > 0) {
      nombreEnfant--;
    }    
    this.sitFamForm.get('nbEnfant').patchValue(nombreEnfant.toString());
  }  
 
}
